import { Button, Icon } from '@zoom/components';
import classnames from 'classnames';
import { format, isSameWeek, startOfWeek } from 'date-fns';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useAuth } from '../../app/AuthorizationProvider';
import { DatePickerValueType } from './DatePicker';

interface PeriodStartButtonProps {
  handlePickedDate: (value: DatePickerValueType) => void;
  pickedDate: Date | number;
}

// Use only for week view in old design
export const PeriodStartButton: React.FC<PeriodStartButtonProps> = ({ handlePickedDate, pickedDate }) => {
  const { localeObj } = useAuth();
  const { t } = useTranslation();

  const currentDate = new Date();

  const isCurrentDateRange = isSameWeek(currentDate, pickedDate, { locale: localeObj });
  const startOfRange = startOfWeek(currentDate, { locale: localeObj });
  const buttonText = isCurrentDateRange
    ? t('date.isCurrentWeek')
    : `${t('date.jumpToCurrentDate')} (${format(currentDate, t('date.formats.default'), { locale: localeObj })})`;

  return (
    <Button
      className={classnames('button--icon--left-hand-side', 'text-decoration-none', {
        'button--icon--no-left-padding': isCurrentDateRange,
      })}
      color={isCurrentDateRange ? 'link' : 'primary'}
      data-test-id="current-day-button"
      disabled={isCurrentDateRange}
      onClick={() => handlePickedDate(startOfRange)}
      title={t('date.jumpToCurrentDate')}
    >
      {!isCurrentDateRange && <Icon color="white" kind="chevron-left" size={14} />}
      {buttonText}
    </Button>
  );
};
